var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'my-box': _vm.speaker==='my', 'other-box': _vm.speaker==='other'}},[_c('p',{staticClass:"message",style:({ 
        'background': _vm.speaker==='my' ? _vm.color.balloonMy : _vm.color.balloonOtr + '!important', 
        'color': _vm.autoColor(_vm.speaker==='my' ? _vm.color.balloonMy : _vm.color.balloonOtr),
        'filter': _vm.shadowStyle(_vm.color.shadowType)})},[_vm._v("\n  回答を記録しました\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289da280","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BalloonParts/OutputParts.vue
// module id = null
// module chunks = 